import { useApiMutation } from "./useApiMutation";
import { MethodType } from "../types/ApiRequest";
import { logger } from "../Logger";
import config from "../config/config";

export const useLogout = () => {
  const mutation = useApiMutation<{ sessionId: string; userUid: string }>(
    {
      url: `${config.tcTeamsWebApiUrl}/auth/logout`,
      method: MethodType.POST,
      key: "logout",
      action: "useLogout",
    },
    logger
  );

  return mutation;
};
